import { render, staticRenderFns } from "./TableRiskAppraisalDHCD.vue?vue&type=template&id=5ceabcd9&scoped=true"
import script from "./TableRiskAppraisalDHCD.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisalDHCD.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisalDHCD.vue?vue&type=style&index=0&id=5ceabcd9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ceabcd9",
  null
  
)

export default component.exports